import React from 'react';
import {Image, StyleSheet, TouchableOpacity, View} from 'react-native';
import {SvgCssUri} from 'react-native-svg';

import {AppRoute} from '../models/AppRoute';
import useAppNavigation from '../navigation/useAppNavigation';
import theme from '../style/theme';

import Text from './ui-controls/Text';

type SearchBrandAbbreviatedTileProps = {
  item: any;
  onPress?: (item: any) => void;
};

const SearchBrandAbbreviatedTile = ({item, onPress}: SearchBrandAbbreviatedTileProps) => {
  const navigation = useAppNavigation();

  const _onPress = (brand: any) => {
    if (onPress) {
      onPress(brand);
    } else {
      navigation.navigate(AppRoute.BRAND, {brand});
    }
  };

  const getBrandImage = (detail: any) => {
    if (detail.type.endsWith('png')) {
      return (
        <View style={styles.logoImageHolder}>
          <Image source={{uri: detail.url}} style={styles.logoImage} resizeMode="contain" />
        </View>
      );
    } else if (detail.type.endsWith('svg+xml')) {
      return (
        <View style={styles.logoImageSVG}>
          <SvgCssUri width="95%" height="95%" uri={detail.url} />
        </View>
      );
    } else {
      return (
        <View style={styles.logoImage}>
          <Text>unk</Text>
        </View>
      );
    }
  };

  return (
    <TouchableOpacity onPress={() => _onPress(item)} style={styles.item} key={item.id}>
      <View style={styles.itemInside}>
        <View style={styles.leftCol}>{getBrandImage(item.logo[0])}</View>
        <View style={styles.rightCol}>
          <Text style={styles.itemText}>{item.headline}</Text>
          <Text style={styles.copyStyle} numberOfLines={2} adjustsFontSizeToFit={false}>
            {item.copy}
          </Text>
        </View>
      </View>
    </TouchableOpacity>
  );
};

export default SearchBrandAbbreviatedTile;

const styles = StyleSheet.create({
  // Image Side
  leftCol: {
    flex: 1,
    marginVertical: 1,
    justifyContent: 'center',
  },
  tileImage: {
    width: '100%',
    aspectRatio: 1,
    marginVertical: 4,
  },
  item: {
    borderWidth: 0.5,
    borderColor: 'grey',
    borderRadius: 4,
    paddingLeft: 4,
    backgroundColor: 'white',
  },
  itemInside: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  // Text side
  rightCol: {
    flex: 4,
    paddingHorizontal: 12,
    paddingVertical: 4,
    alignSelf: 'stretch',
    // justifyContent: 'space-between',
  },
  nameRow: {
    flexDirection: 'row',
    borderWidth: 1,
  },
  itemText: {
    color: theme.colour.text.heading.primary,
    fontSize: 16,
    fontWeight: 'bold',
  },
  priceButtonRow: {
    flexDirection: 'row',
    alignSelf: 'center',
  },
  itemQty: {
    color: 'grey',
    fontSize: 12,
  },
  priceLine: {
    flexDirection: 'row',
    alignItems: 'baseline',
  },
  originalPrice: {
    color: 'grey',
    fontSize: 12,
    fontWeight: 'bold',
  },
  price: {
    fontSize: 12,
    color: theme.colour.text.heading.primary,
  },
  priceUnit: {
    fontSize: 12,
    color: 'grey',
  },
  basketButtons: {
    flex: 1,
    alignItems: 'flex-end',
    justifyContent: 'center',
    marginRight: 8,
  },
  copyStyle: {
    paddingTop: 2,
    lineHeight: 16,
    fontSize: 13,
  },
  logoImageHolder: {
    // shadowColor: '#000',
    // shadowOffset: {
    //   width: 0,
    //   height: 5,
    // },
    // shadowOpacity: 0.29,
    // shadowRadius: 4.65,
    // elevation: 2,
    // borderRadius: 4,
    backgroundColor: 'white',
    // width: '24%',
    aspectRatio: 1,
    padding: 2,
  },
  logoImage: {
    height: '100%',
    aspectRatio: 1,
    backgroundColor: 'white',
  },
  logoImageSVG: {
    backgroundColor: 'white',
    height: '90%',
    aspectRatio: 1,
    justifyContent: 'center',
    alignItems: 'center',

    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 5,
    },
    shadowOpacity: 0.29,
    shadowRadius: 4.65,
    elevation: 2,
  },
});
